const data = {
  pageName: "BillPayment",

  //optional
  //initiallyPhoneSelected: false,

  services: {
    translations: {
      url: "billPayment/translations",
      params: {}
    },
    retrieveBalance: {
      url: "billPayment/retrieveBalance",
      params: {}
    },
    sendOTP: {
      url: "billPayment/sendBalanceOTP",
      params: {}
    },
    validateOTP: {
      url: "billPayment/validateBalanceOTP",
      params: {}
    }
  },

  systemUnavailable_OSB: "",
  systemUnavailable_SAP: "",
  systemUnavailable_AlphaBank: null,
  systemUnavailable_Paypal: "",

  externalContent: {
    BillPayment: {
      bottom: "/ext_files/test-pages/billPayment-tiles-content.html"
    }
  },

  news: [
    {
      body:
        "Μέσω της πλατφόρμας Alpha e-Commerce είμαστε πλήρως συμβατοί με τα πρωτόκολλα ασφαλείας 3D-Secure των διεθνών οργανισμών καρτών Visa Secure, Mastercard Identity Check και American Express SafeKey®.<br /><br />Για ασφαλείς online πληρωμές με κάρτα σύμφωνα με τις βέλτιστες διεθνείς πρακτικές στον τομέα των πληρωμών, και με τις πλέον σύγχρονες διεθνείς υπηρεσίες ασφαλείας!",
      id: 1490639370334,
      desktopImage:
        "http://localhost:3000/ext_files/app/images/payments/secure-desktop.png",
      mobileImage:
        "http://localhost:3000/ext_files/app/images/payments/secure-mobile.png",
      imageAlternateText: "secure",
      title: "Γρήγορα, εύκολα αλλά πάντα με ασφάλεια!"
    },
    {
      body:
        'Tώρα έχεις άλλους δύο λόγους για να επιλέξεις ηλεκτρονική πληρωμή!<br /><br />Μπορείς να πληρώσεις τις οφειλές σου με πιστωτική κάρτα άτοκα έως 6 δόσεις. Αλλά και να μειώσεις τον λογαριασμό σου εξαργυρώνοντας Bonus πόντους χρησιμοποιώντας πιστωτικές ή χρεωστικές κάρτες Alpha Bank Bonus.<br /><br /><img alt="bonus logo" src="ext_files/app/images/payments/bonus-logo.png" />',
      id: 1490639370679,
      desktopImage:
        "http://localhost:3000/ext_files/app/images/payments/bonus-desktop.png",
      mobileImage:
        "http://localhost:3000/ext_files/app/images/payments/bonus-mobile.png",
      imageAlternateText: "bonus",
      title: "Πληρωμή με δόσεις, αλλά και με Alpha bonus!"
    },
    {
      body:
        'Πλήρωσε τώρα εύκολα και γρήγορα, όπου και αν είσαι, με την αποθηκευμένη σου κάρτα!<br /><br />Συνδέσου στον λογαριασμό σου στο vodafone.gr ή στο My Vodafone app, για να δεις το ποσό της οφειλής σου, να διαλέξεις μια από τις αποθηκευμένες σου κάρτες και να πληρώσεις...on the go!<br /><br /><strong>Κατέβασε το app από εδώ:</strong><br /><br /><a href="https://play.google.com/store/apps/details?id=com.myvodafone.android" target="_blank"><img alt="play store" src="ext_files/app/images/mva/mva_googleplay.png" /></a> <a href="https://itunes.apple.com/gr/app/my-vodafone/id386764438?mt=8" target="_blank"><img alt="app store" src="ext_files/app/images/mva/mva_app-store.png" /></a>',
      id: 1490639371472,
      desktopImage:
        "http://localhost:3000/ext_files/app/images/payments/saved-desktop.png",
      mobileImage:
        "http://localhost:3000/ext_files/app/images/payments/saved-mobile.png",
      imageAlternateText: "saved card",
      title: "Πληρωμή με αποθηκευμένη κάρτα"
    }
  ]
};

exports.data = data;
